import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_8: FaireProductEntity = {
  token: "nyc-soap-8",
  type: "product",
  name: "Charcoal Face Mask",
  brandName: "Pure Botanicals",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/063dc0dc2c87f13b1502d284bdd1a8d8131f156cf92bb254353ad050e51690ec.webp",
  priceDollars: 22,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/063dc0dc2c87f13b1502d284bdd1a8d8131f156cf92bb254353ad050e51690ec.webp",
  weight: 0.6,
  dimensions: {
    width: 3,
    height: 3,
    depth: 3,
  },
  description: "Premium shea butter balm from SoHo",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "organic", "luxury"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
